module.exports = __webpack_public_path__ + "static/media/1.636b3551.jpg";